/* @flow */
import * as React from 'react';

import AdminAddAdmin from './AdminAddAdmin';
import Dialog from 'components/Dialog';

import type { OrganizationInfo } from 'admin/components/AdminAdminsView';

type Props = {
  organizations: Array<OrganizationInfo>,
  organizationType: string,
  districtId: ?Backbone$Id,
  onRequestHide: () => void,
};

class AdminAddAdminModal extends React.Component<Props, *> {
  render() {
    return (
      <Dialog
        size="small"
        title={`
          Add an admin to your
          ${' '}
          ${this.props.organizationType}
        `}
        onRequestHide={this.props.onRequestHide}>
        <AdminAddAdmin {...this.props} />
      </Dialog>
    );
  }
}

export default AdminAddAdminModal;
